export const NEW_FOLDER_ID_PREFIX = 'new-folder-';

export const PIXEL_LIMIT = 5_000 * 5_000;
